import { PropsWithChildren, ReactNode } from "react"

import CloseIcon from "@mui/icons-material/Close"
import {
  Dialog,
  Drawer,
  Divider,
  IconButton,
  Stack,
  useMediaQuery,
  DialogProps,
  DrawerProps,
  Typography,
} from "@mui/material"
import theme from "@skistarab/mui-theme"

type ResponsiveModalProps = {
  open: boolean
  title: string
  captionText?: string
  footer: ReactNode
  dialogProps?: Partial<DialogProps>
  drawerProps?: Partial<DrawerProps>
  onClose: () => void
}

const ResponsiveDrawer = ({
  open,
  title,
  captionText,
  footer,
  dialogProps,
  drawerProps,
  children,
  onClose,
}: PropsWithChildren<ResponsiveModalProps>) => {
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"))

  const headerContent = (
    <>
      <Stack p={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          <IconButton
            onClick={onClose}
            aria-label="Close"
            sx={{ margin: "-8px", color: "text.primary" }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        {captionText && (
          <Typography variant="caption">{captionText}</Typography>
        )}
      </Stack>

      <Divider />
    </>
  )

  const footerContent = footer && (
    <>
      <Divider />
      <Stack direction="row" spacing={2} padding={2} justifyContent="flex-end">
        {footer}
      </Stack>
    </>
  )

  const modalContent = (
    <>
      {headerContent}
      <Stack p={2} flexGrow={1} sx={{ overflowY: "auto" }}>
        {children}
      </Stack>
      {footerContent}
    </>
  )

  if (isDesktop) {
    return (
      <Dialog open={open} onClose={onClose} fullWidth {...dialogProps}>
        {modalContent}
      </Dialog>
    )
  }

  return (
    <Drawer anchor="bottom" open={open} onClose={onClose} {...drawerProps}>
      {modalContent}
    </Drawer>
  )
}

export default ResponsiveDrawer
